<template>
    <div class="principal">
        <NavBar :usarAberto="true" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="FALSE" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false" :usarFiltroPosicao="false"
            :formatarDataInicioMes="formatarDataInicioMes" />

        <Modal id="ModalGerenciar" :mostrar="true" :usarHeader="false" :usarFooter="false" @fechar="fechar()">
            <template v-slot:corpo>
                <div class="d-flex btns">
                    <RouterLink class="btn btn-success" to="/historico">
                        Histórico
                    </RouterLink>
                    <RouterLink class="btn btn-success" to="/RelatorioTempo">
                        Tempo de Atendimento
                    </RouterLink>
                    <RouterLink class="btn btn-success" to="/RelatorioMediaEstrela">
                        Média de Estrelas
                    </RouterLink>
                    <RouterLink class="btn btn-success" to="/RelatorioAtendEstrela">
                        Satisfação do Cliente
                    </RouterLink>
                    <RouterLink class="btn btn-success" to="/RelatorioAtendTempo">
                        Atendimento ao Longo do Tempo
                    </RouterLink>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script setup>
import Modal from '@/components/Modal.vue';
import store from '@/store/store';
import _versao from '@/../package.json';
import api from '@/api/api';
import NavBar from '@/components/NavBar.vue';
import { RouterLink } from 'vue-router';
import router from '@/roteador/indexRoteador';
import { reactive, onMounted, computed, defineProps } from 'vue';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    versao: _versao.version,
    mensagem: String(),
    comMensagem: Boolean(),
    comAviso: false,
    funcLimpar: false,
    aviso: "",
    motivo: "",
});

function deslogar() {
    sessionStorage.removeItem("TokenReguaPainel");
    router.back();
}

function retAbertos() {
    router.back();
}

async function limparPainel() {
    state.funcLimpar = true;
    state.aviso = "Deseja limpar todos os chamados abertos ? ";
    state.comAviso = true;
}

async function modalConfirma(result) {
    if (state.funcLimpar && result == "ok") {
        if (state.motivo.trim().length == 0) {
            state.mensagem = "Preencha o motivo antes de continuar";
            state.comMensagem = true;
            return;
        } else {
            await api.chamadoLimparLeito(state.motivo, 0)
                .then(resp => {
                    state.mensagem = "Status: " + resp + ", o painel foi limpo com sucesso";
                    state.comMensagem = true;
                })
                .catch(erro => {
                    state.mensagem = erro;
                    state.comMensagem = true;
                });
        }
    }

    state.funcLimpar = false;
    state.aviso = "";
    state.comAviso = false;
}

function fechar() {
    state.mensagem = String();
    state.comMensagem = false;
}

const tipoChamado = computed(() => {
    return store.state.tipoChamado;
});

const token = computed(() => {
    return (sessionStorage.TokenReguaPainel) ? true : false;
});

</script>

<style scoped>
.btn {
    margin-bottom: 1rem;
}

.btns {
    flex-direction: column;
}
</style>